import { useService } from 'shared/providers';

export function useI2PEnvironment() {
    const {
        appConfig: { serviceBaseUrl },
    } = useService();

    const isDev = serviceBaseUrl.includes('dev');
    const isSandbox = serviceBaseUrl.includes('sandbox');

    return {
        isDev,
        isSandbox,
        isProd: !isDev && !isSandbox,
    };
}
